// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";
import { Headline } from "#/components/headline/Headline";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
  },
})
export class TabsContentTableModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  /**
   * remove columns, which are empty in each row
   */
  private get tableRows() {
    let rows = JSON.parse(JSON.stringify(this.instance["rows"]));
    let colCount = Object.keys(rows[0]).length;

    for (let c = 0; c < colCount; c++) {
      let doNext = false;
      for (let r = 0; r < rows.length; r++) {
        let row = rows[r];

        let colName = `col${c + 1}`;
        let col = row[colName];

        // check if column has image or text
        if (col.image || col.text) {
          // go to next column
          doNext = true;
          break;
        }
      }

      if (doNext) {
        doNext = false;
        continue;
      }

      // a col is empty in each row, delete it
      for (let r = 0; r < rows.length; r++) {
        let colName = `col${c + 1}`;
        delete rows[r][colName];
      }
    }

    return rows;
  }

  get getHeadlineSize() {
    switch (this.instance["headline"]["type"]) {
      case "h1":
        return 1;
      case "h2":
        return 2;
      case "h3":
        return 3;
      case "subline":
        return 4;
      default:
        return 1;
    }
  }

  get getColorClass() {
    let color = this.instance["color"];

    return color == "white" ? "white" : "black";
  }

  get getSecondColorClass() {
    let color = this.instance["color"];

    return color == "white" ? "black" : "white";
  }

  get headlineTheme() {
    let color = this.instance["background"];
    return color == "black" ? "secondary" : "default";
  }

  get hasMgsLine() {
    if (this.instance["headline"]["type"] == "h2") {
      return true;
    }
  }
}
